import { ChildVenue } from "../types/dataTypes.ts";

export const cityLandingPageInfo: {
  slug: string;
  locationName: string;
  cityAvailableVenuesText: string;
  cityLatitude: number;
  cityLongitude: number;
  nearby_venues: ChildVenue[];
}[] = [
  {
    slug: "dublin",
    cityAvailableVenuesText:
      "View combined film listings for IMC Savoy, Cineworld Dublin, Irish Film Institute, Odeon Point Square, Omniplex Dublin - Rathmines, and many more...",
    cityLatitude: 53.349805,
    cityLongitude: -6.26031,
    nearby_venues: [
      {
        venue_name: "IMC Savoy",
        distanceBetweenUserAndVenue: 0.18047179682085485,
        venue_slug: "imc-savoy",
      },
      {
        venue_name: "Cineworld Dublin",
        distanceBetweenUserAndVenue: 0.6614731323591858,
        venue_slug: "cineworld-dublin",
      },
      {
        venue_name: "Irish Film Institute",
        distanceBetweenUserAndVenue: 2.104720124690629,
        venue_slug: "irish-film-institute",
      },
      {
        venue_name: "Odeon Point Square",
        distanceBetweenUserAndVenue: 2.172280223730371,
        venue_slug: "odeon-point-square",
      },
      {
        venue_name: "Omniplex Dublin - Rathmines",
        distanceBetweenUserAndVenue: 2.915840749828571,
        venue_slug: "omniplex-dublin-rathmines",
      },
      {
        venue_name: "Stella Cinema",
        distanceBetweenUserAndVenue: 3.5157933970949697,
        venue_slug: "stella-cinema",
      },
      {
        venue_name: "IMC Santry",
        distanceBetweenUserAndVenue: 4.883495707709796,
        venue_slug: "imc-santry",
      },
      {
        venue_name: "UCD Cinema",
        distanceBetweenUserAndVenue: 5.024069057261411,
        venue_slug: "ucd-cinema",
      },
      {
        venue_name: "The Devlin",
        distanceBetweenUserAndVenue: 5.901610149995369,
        venue_slug: "the-devlin",
      },
      {
        venue_name: "Omniplex Dublin - Nutgrove",
        distanceBetweenUserAndVenue: 6.727739096527039,
        venue_slug: "omniplex-dublin-nutgrove",
      },
      {
        venue_name: "Movies@ Dundrum",
        distanceBetweenUserAndVenue: 6.988297395282059,
        venue_slug: "movies-dundrum",
      },
      {
        venue_name: "Odeon Charlestown",
        distanceBetweenUserAndVenue: 7.1680143601013375,
        venue_slug: "odeon-charlestown",
      },
      {
        venue_name: "Light House",
        distanceBetweenUserAndVenue: 7.505662523916142,
        venue_slug: "light-house",
      },
      {
        venue_name: "Odeon Stillorgan",
        distanceBetweenUserAndVenue: 7.681144234240837,
        venue_slug: "odeon-stillorgan",
      },
      {
        venue_name: "Vue Dublin (Liffey Valley)",
        distanceBetweenUserAndVenue: 9.176215302530629,
        venue_slug: "vue-dublin-liffey-valley",
      },
      {
        venue_name: "Odeon Blanchardstown",
        distanceBetweenUserAndVenue: 10.21054535446689,
        venue_slug: "odeon-blanchardstown",
      },
      {
        venue_name: "Movies@ The Square",
        distanceBetweenUserAndVenue: 10.22340779067934,
        venue_slug: "movies-the-square",
      },
      {
        venue_name: "IMC Dun Laoghaire",
        distanceBetweenUserAndVenue: 10.434111424548226,
        venue_slug: "imc-dun-laoghaire",
      },
    ],
    locationName: "Dublin",
  },
  {
    slug: "cork",
    cityAvailableVenuesText:
      "View combined film listings for Triskel Arts Centre, The Arc Cork, The Reel Picture Blackpool, Omniplex Cork, The Reel Picture Ballincollig, and many more...",
    cityLatitude: 51.898514,
    cityLongitude: -8.475604,
    nearby_venues: [
      {
        venue_name: "Triskel Arts Centre",
        distanceBetweenUserAndVenue: 0.2596658580945398,
        venue_slug: "triskel-arts-centre",
      },
      {
        venue_name: "The Arc Cork",
        distanceBetweenUserAndVenue: 0.3830917930833145,
        venue_slug: "the-arc-cork",
      },
      {
        venue_name: "The Reel Picture Blackpool",
        distanceBetweenUserAndVenue: 2.057065705014794,
        venue_slug: "the-reel-picture-blackpool",
      },
      {
        venue_name: "Omniplex Cork",
        distanceBetweenUserAndVenue: 5.723228272386638,
        venue_slug: "omniplex-cork",
      },
      {
        venue_name: "The Reel Picture Ballincollig",
        distanceBetweenUserAndVenue: 7.846050392227841,
        venue_slug: "the-reel-picture-ballincollig",
      },
    ],
    locationName: "Cork",
  },
  {
    slug: "limerick",
    cityAvailableVenuesText:
      "View combined film listings for Vue Limerick, Omniplex Limerick, Odeon Limerick, and many more...",
    cityLatitude: 52.663836,
    cityLongitude: -8.626735,
    nearby_venues: [
      {
        venue_name: "Vue Limerick",
        distanceBetweenUserAndVenue: 2.4152196133590405,
        venue_slug: "vue-limerick",
      },
      {
        venue_name: "Omniplex Limerick",
        distanceBetweenUserAndVenue: 2.8828548414079376,
        venue_slug: "omniplex-limerick",
      },
      {
        venue_name: "Odeon Limerick",
        distanceBetweenUserAndVenue: 4.959562495370029,
        venue_slug: "odeon-limerick",
      },
    ],
    locationName: "Limerick",
  },
  {
    slug: "galway",
    cityAvailableVenuesText:
      "View combined film listings for IMC Galway Headford Road, Eye Cinema Galway, Omniplex Galway - Salthill, IMC Galway Oranmore, and many more...",
    cityLatitude: 53.274209,
    cityLongitude: -9.049061,
    nearby_venues: [
      {
        venue_name: "IMC Galway Headford Road",
        distanceBetweenUserAndVenue: 0.6156069095914816,
        venue_slug: "imc-galway-headford-road",
      },
      {
        venue_name: "Eye Cinema Galway",
        distanceBetweenUserAndVenue: 1.2771375880750195,
        venue_slug: "eye-cinema-galway",
      },
      {
        venue_name: "Omniplex Galway - Salthill",
        distanceBetweenUserAndVenue: 2.5023410321175112,
        venue_slug: "omniplex-galway-salthill",
      },
      {
        venue_name: "IMC Galway Oranmore",
        distanceBetweenUserAndVenue: 8.08144464224076,
        venue_slug: "imc-galway-oranmore",
      },
    ],
    locationName: "Galway",
  },
  {
    slug: "waterford",
    cityAvailableVenuesText:
      "View combined film listings for Omniplex Waterford and Odeon Waterford.",
    cityLatitude: 52.25932,
    cityLongitude: -7.11007,
    nearby_venues: [
      {
        venue_name: "Omniplex Waterford",
        distanceBetweenUserAndVenue: 0.1976050570604482,
        venue_slug: "omniplex-waterford",
      },
      {
        venue_name: "Odeon Waterford",
        distanceBetweenUserAndVenue: 0.511865054787117,
        venue_slug: "odeon-waterford",
      },
    ],
    locationName: "Waterford",
  },
];
